import React from "react";
import { Link } from "react-router-dom";
import {
  Star,
  ArrowLeft,
  Monitor,
  Wrench,
  Search,
  Facebook,
  MousePointerClick,
  Magnet,
} from "lucide-react";
import SiteNavbar from "@/components/SiteNavbar";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";

const SERVICES = [
  {
    icon: Monitor,
    title: "Web Design",
    text: "We build fast, professional websites designed to win you customers — not just look pretty. Every site is mobile-friendly, SEO-ready, and built to convert visitors into enquiries.",
  },
  {
    icon: Wrench,
    title: "Website Maintenance",
    text: "We keep your site updated, secure, and running perfectly every month. Hosting, security, updates, and changes all covered — you never have to think about it.",
  },
  {
    icon: Search,
    title: "SEO",
    text: "We get your business ranking at the top of Google so customers find you before they find your competitors. Local SEO specialists covering Surrey and the South East.",
  },
  {
    icon: Facebook,
    title: "Meta Ads",
    text: "We run targeted Facebook and Instagram campaigns that put your business in front of the right people at the right time. Every campaign is managed, monitored, and optimised for results.",
  },
  {
    icon: MousePointerClick,
    title: "Google Ads",
    text: "We manage your Google ad campaigns to drive high-intent customers straight to your door. Pay for clicks that actually turn into customers.",
  },
  {
    icon: Magnet,
    title: "Lead Generation",
    text: "We build and manage systems that bring in a consistent stream of enquiries so your pipeline never runs dry. More leads, less chasing.",
  },
];

export default function Services() {
  return (
    <div className="min-h-screen bg-[#0a1f3d] text-white">
      <SiteNavbar />

      <main className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-sm text-white/80">
          <Star className="h-4 w-4 text-[#e9a31e]" />
          Our Services
        </div>

        <h1 className="mt-6 text-4xl font-extrabold tracking-tight sm:text-6xl">
          Our <span className="text-[#e9a31e]">Services</span>
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-white/70">
          Everything your business needs to get found online and turn visitors
          into customers.
        </p>

        <Reveal>
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                className="group rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-all duration-200 hover:-translate-y-1 hover:border-[#e9a31e]/40"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#e9a31e]/15 text-[#e9a31e]">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-5 text-xl font-bold">{s.title}</h3>
                <p className="mt-2 text-white/70">{s.text}</p>
              </article>
            );
          })}
        </div>
        </Reveal>

        <Reveal>
        <div className="mt-14 flex flex-col items-start gap-5 rounded-2xl border border-white/10 bg-gradient-to-br from-[#0e2647] to-[#0a1f3d] p-8 md:flex-row md:items-center md:justify-between">
          <p className="max-w-2xl text-lg text-white/80">
            Not sure which service you need? Book a free 30-minute audit and
            we’ll tell you exactly what will move the needle for your business.
          </p>
          <Link
            to="/audit"
            className="w-full shrink-0 rounded-lg bg-[#e9a31e] px-6 py-3.5 text-center text-base font-bold text-[#0a1f3d] transition-colors hover:bg-[#f2b743] md:w-auto"
          >
            Book Free Audit
          </Link>
        </div>
        </Reveal>
      </main>

      <Footer />
    </div>
  );
}
